<template>
    <el-row type="flex" justify="center" class="centerss">
        <el-col
            :span="24"
            style="background:#fff;width:100%;height: 60px;
            border-bottom: 1px solid #eee;"
            >
            <div class="grid-content bg-purple-dark">
                <div style="float:left;line-height: 60px;height:60px;outline: none;">
                    <p style="width: 100px;position: relative;display: inline-block;">
                        <span class="log"></span>
                    </p>
                    <p style=" display: inline-block;color:#999">SFC Order Fulfillment</p>
                </div>
            </div>
        </el-col>

        <div class="centersa">

            <div style="left:0">
                <p style=" padding: 20px 0;color:#333;font-size:16px;font-weight: normal;" >Registered</p>
                <el-form ref="registerfrom" :model="registeruser" :rules="registerrules" @submit.native.prevent>
                    <el-form-item >
                        <el-input v-model="registeruser.email" placeholder="E-mail" ></el-input>
                    </el-form-item>

                    <el-form-item prop="pass">
                        <el-input v-model="registeruser.pass" placeholder="Password" type="text" maxlength="20" onkeydown="if(event.keyCode==32){return false}"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="agree" class="iagree">I agree to the Terms & Conditions in the <a class="linkBtn" href="http://www.sendfromchina.com/app/upload/docs/Shipping_Service_SLA.pdf" target="_break">Service Level Agreement</a></el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <p class="canBtns" v-bind:class="{'disabledBtns':!abled || !agree}" @click="register">Confirm</p>
                    </el-form-item>
                </el-form>

            </div>
            <div style="line-height: 400px;">
                Already have an account ?  <router-link to="/login"> <a style="color: #8989ba;cursor: pointer;text-decoration: underline;">Sign in now</a> </router-link>
            </div>
        </div>
    </el-row>
</template>

<script>
import { UrlSearch } from '../../utils/UrlSearch'
import { loginfromshopify, getcountry, register, getShopInf } from '../api/user'
import { setToken, removeToken } from '../../utils/auth'
import { getRegion } from '../api/apis/user'
import store from '@/store'
var userparam = UrlSearch()
console.log(userparam.shop)
var shop = 'allenshows'
if (userparam.shop) {
  console.log(userparam.shop)
  var url = userparam.shop
  var index = url.indexOf('.')
  shop = url.substring(0, index)
}
const TIME_COUNT = 60 // 更改倒计时时间
export default {
  mounted () {
    if (userparam.shop == undefined) {
      // removeToken()
      store.dispatch('setUser', null)
      this.$router.push({ path: '/404' })
    }
  },
  created () {
    getShopInf({shop: shop}).then(response => {
      if (response.data.ask === 1) {
        this.registeruser.email = response.data.email
      } else {
        this.$message({
          message: 'Failed to get mailbox, please contact administrator',
          type: 'warning'
        })
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    register () {
      if (this.registeruser.email === '' || this.registeruser.pass === '') {
        return
      }
      this.$refs.registerfrom.validate(valid => {
        if (valid) {
          const params = {
            shop: shop,
            email: this.registeruser.email,
            password: this.registeruser.pass
          }
          console.log(params)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0, 0,.7)'
          })
          register(params).then(response => {
            console.log(response)
            if (response.data.ask === 1) {
              // setToken("apps", response.data.apps);
              // setToken("user", response.data.userData); 这里
              store.dispatch('setApps', response.data.apps)
              store.dispatch('setUser', response.data.userData)
              store.dispatch('updateusername', response.data.userData.customer_id)
              this.$router.push({ path: '/home' })
            } else {

            }
            loading.close()
          }).catch(err => {
            loading.close()
            console.log(err)
          })
        } else {
          return false
        }
      })
    }
  },
  data () {
    // 校验密码
    const checkPw = (rule, value, callback) => {
      // const reg = /^[^\u4e00-\u9fa5]{1,}$/;
      // let checkPass = true;
      // if(!value){
      //     this.disabled = true;
      //     return
      // }else{
      //     if(value.length<6){
      //         checkPass = false;
      //         callback(new Error('Password length not less than 6 bits'))
      //     }
      //     if(!reg.test(value)){
      //         checkPass = false;
      //         callback(new Error("Password is not allowed to enter Chinese"));
      //     }
      // }
      // if(checkPass){
      //     this.disabled = false;
      // }else{
      //     this.disabled = true;
      // }
      if (!value) {
        this.abled = false
      } else {
        this.abled = true
      }
      callback()
    }
    return {
      show: true, // 初始启用按钮
      count: '', // 初始化次数
      timer: null,
      abled: false,
      agree: false,
      registerrules: {
        email: [
          { required: false, message: 'Please enter your email address', trigger: 'blur' },
          {
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change']
          }
        ],
        pass: [{ required: true, trigger: 'change', validator: checkPw }]
      },

      registeruser: {
        email: '',
        pass: ''
      }
    }
  }
}
</script>
<style>
.linkBtn{
    color: #10a5f8;
    cursor: pointer;
}
.linkBtn:hover{
    text-decoration: underline;
}
.canBtns{
    width:100%;
    background:#8989ba;
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #8989ba;
    color: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
.disabledBtns{
    background: #ebebeb;
    color: #8a8a8a;
    border-color: #ebebeb;
    /* background:#8989ba;
    color: #fff;
    border-color: #8989ba; */
}
.centerss {
  position: absolute;
  background: #fbf8f8;
  width: 100%;
  height: 100%;
  min-width: 950px;
  top: 0;
}
.centersa {
  position: absolute;
  width: 680px;
  height: 420px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 20px;
}
.centersa > div {
  width: 300px;
  display: inline-block;
  padding: 30px;
  background: #ffff;
  height: 400px;
  border-radius: 5px;
  position: absolute;
}
.centersa > div > form {
  height: 100%;
}
.iagree .el-checkbox__input{
    position: absolute;
    top: 4px;
}
.iagree .el-checkbox__label{
    white-space: normal;
    margin-left: 14px;
    word-break: break-word;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/Register.vue